var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"my-0"},[_c('v-col',{staticClass:"pt-0 pb-7",attrs:{"cols":"12"}},[_c('h1',{staticClass:"accent--text"},[_vm._v(_vm._s(_vm.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }